import React from 'react';
import TypeTag from '../tags/TypeTag.js';
import ImpactAttributeTag from '../tags/ImpactAttributeTag.js';

const FeedbackListElement = ({ 
    testType, 
    impactAttribute, 
    testName, 
    result, 
    issueMessage, 
    failureMode, 
    overriddenStatus,
    children 
}) => {
    return (
        <div className="list-element" style={{ backgroundColor: result === null ? '#eee' : (result === 1 ? '#eee' : '#fad4d4') }}>
            <div className="small-div" style={{ display: 'flex', flexDirection: 'column'}}>
                <div className='large-div' style={{ display: 'flex', flexDirection: 'row' }}>
                    <div className="tiny-div">
                    </div>
                    <div className="large-div" style={{ justifyContent: 'center' }}>
                        <div className="element-name" style={{ fontSize: 'larger' }}> {issueMessage} </div>
                    </div>
                    <div className="tiny-div" style={{ justifyContent: 'right' }}>
                        {/* <i className="fa-solid fa-circle-info"></i> */}
                    </div>
                </div>
                <div className='large-div' style={{ display: 'flex', flexDirection: 'row' }}>
                    <div className="small-div" style={{ display: 'flex', alignItems: 'flex-start' }}>
                        <TypeTag reportType={testType} isButton={false}/>
                        <ImpactAttributeTag attributeType={impactAttribute} isButton={false}/>
                    </div>
                    <div className="large-div" style={{ justifyContent: 'center' }}>
                        <div className="element-name" style={{ fontSize: '16px', marginTop: 'auto' }}> {testName} </div>
                    </div>
                    <div className="small-div" style={{ justifyContent: 'right' }}>
                        {children}
                    </div>
                </div>
                {(failureMode && !overriddenStatus) && (
                    <div className="small-div" style={{ marginTop: 20 }}>
                        <p><strong><u>Reason</u>:</strong> {failureMode}</p> 
                    </div>
                )}
            </div>
        </div>
    );
};

export default FeedbackListElement; 